import React, { useEffect, useState } from 'react';
import FaceCaptureComponent from './FaceDetection';
import './App.css';
import { User, Clock, Timer, LogOut, LogIn } from "lucide-react";
import packageJson from '../package.json';

function App() {
  const [mode, setMode] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || ''
  );

  const [showGif, setShowGif] = useState(false);

  // Toggle between Logo and GIF
  useEffect(() => {
    const interval = setInterval(() => {
      setShowGif(prev => !prev);
    }, 4000); // Toggle every 4 seconds
    return () => clearInterval(interval);
  }, []);

  const handleBack = () => {
    setMode(null);
  };

  // Handle browser back button (History API)
  useEffect(() => {
    if (mode) {
      // Push state when entering a mode so back button works
      window.history.pushState({ mode }, '', window.location.pathname);

      const handlePopState = (event) => {
        // When back button is pressed, event.state is usually null (or previous state)
        // We just reset mode to null to go back to menu
        setMode(null);
      };

      window.addEventListener('popstate', handlePopState);
      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [mode]);

  useEffect(() => {
    const updateInstallState = () => {
      const standalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
      const iosStandalone = window.navigator.standalone === true;
      setIsInstalled(standalone || iosStandalone);
      if (standalone || iosStandalone) {
        document.body.classList.add('pwa-installed');
      } else {
        document.body.classList.remove('pwa-installed');
      }
    };

    updateInstallState();
    const media = window.matchMedia && window.matchMedia('(display-mode: standalone)');
    const mediaListener = () => updateInstallState();
    media && media.addEventListener('change', mediaListener);
    window.addEventListener('appinstalled', updateInstallState);

    const handler = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setCanInstall(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', updateInstallState);
      media && media.removeEventListener('change', mediaListener);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setCanInstall(false);
    }
    setDeferredPrompt(null);
  };

  return (
    // <div className="app-container">
    //   {!mode && (
    //     <>
    //       <h1>Attendance System</h1>
    //     <img src="/logo192.png" alt="Logo" /><br/>
    //       <button className="main-button" onClick={() => setMode('registration')}>
    //         Registration
    //       </button>
    //       <button className="main-button" onClick={() => setMode('punchin')}>
    //         Punch In
    //       </button>
    //        <button className="main-button" onClick={() => setMode('breakin')}>
    //         Break In
    //       </button>
    //        <button className="main-button" onClick={() => setMode('breakout')}>
    //         Break Out
    //       </button>
    //        <button className="main-button" onClick={() => setMode('punchout')}>
    //         Punch Out
    //       </button>
    //     </>
    //   )}


    // </div>
    <div className="mobile-container">
      {!mode && (
        <div className="neu-card" >
          {/* Header */}
          <div className="flex items-center justify-center mb-6">
            <div className="w-8 h-8 bg-gray-400 rounded-full flex items-center justify-center overflow-hidden">
              {/* <User className="w-5 h-5 text-gray-400" style={{ color: '#ffffff' }} /> */}
              <img
                src={showGif ? "/capture-sample.gif" : "/logo192.png"}
                alt="Logo"
                className="w-full h-full object-cover"
                style={{ color: '#ffffff', width: "100%" }}
              />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-400" style={{ color: '#ffffff' }}>Welcome!</h1>
              <p className="text-gray-400 text-xs" style={{ color: '#ffffff' }}>
                Please select your preferred activity
              </p>
              <p className="text-gray-400 text-[11px]" style={{ color: '#9ca3af' }}>
                App v{packageJson.version}
              </p>
            </div>
          </div>

          {(isMobile && !isInstalled) && (
            <div className="mb-4" style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '10px', padding: '12px' }}>
              <p style={{ color: '#ffffff', fontWeight: 600, marginBottom: '10px' }}>Install this app for the best experience.</p>
              {canInstall ? (
                <button
                  className="neu-button"
                  style={{ width: '100%' }}
                  onClick={handleInstall}
                >
                  Install App
                </button>
              ) : (
                <p style={{ color: '#d1d5db', fontSize: '0.9em', margin: 0 }}>
                  Tap your browser menu and choose "Add to Home Screen" to install.
                </p>
              )}
            </div>
          )}

          {/* Row 1: Check In / Out */}
          <div className="grid grid-cols-2 gap-3 " style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <button className="neu-button button-check-in w-full" onClick={() => setMode('punchin')}>
              <LogIn className="w-5 h-5 mr-2 text-white" />
              Punch In
            </button>
            <button className="neu-button button-check-out w-full" onClick={() => setMode('punchout')}>
              <LogOut className="w-5 h-5 mr-2 text-white" />
              Punch Out
            </button>
          </div>

          {/* Row 2: Break In / Out */}
          <div className="grid grid-cols-2 gap-3 mb-3" >
            {/* <button className="neu-button button-break-out w-full" style={{ width: '100%' }} onClick={() => setMode('breakout')}>
                <div className="button-icon">
                  <Clock className="w-5 h-5 text-white" />
                </div>
                <span>&nbsp;&nbsp;ब्रेक आउट</span>
            </button>

            <button className="neu-button button-break-in w-full flex" style={{ width: '100%' }} onClick={() => setMode('breakin')}>
              <div className="button-icon">
                <Timer className="w-5 h-5 text-white" />
              </div>
              <span>&nbsp;&nbsp;ब्रेक इन</span>
            </button> */}

            {/* Registration link */}
            <span className="registration-link" style={{ color: '#ffffff' }} onClick={() => setMode('registration')}>Are you new? Register now</span>
          </div>

          {/* Color-coded instruction legend */}
          <div style={{
            marginTop: '20px',
            padding: '15px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '8px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <p style={{
              color: '#ffffff',
              fontSize: '0.85em',
              fontWeight: 'bold',
              marginBottom: '10px',
              textAlign: 'center'
            }}>
              Camera Frame Instructions:
            </p>
            <div style={{ fontSize: '0.75em', color: '#ffffff', lineHeight: '1.8' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                <span style={{
                  display: 'inline-block',
                  width: '12px',
                  height: '12px',
                  background: 'red',
                  borderRadius: '50%',
                  marginRight: '8px'
                }}></span>
                <span>Face not clear</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                <span style={{
                  display: 'inline-block',
                  width: '12px',
                  height: '12px',
                  background: 'orange',
                  borderRadius: '50%',
                  marginRight: '8px'
                }}></span>
                <span>Move closer / Hold still</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                <span style={{
                  display: 'inline-block',
                  width: '12px',
                  height: '12px',
                  background: 'yellow',
                  borderRadius: '50%',
                  marginRight: '8px'
                }}></span>
                <span>Center your face</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{
                  display: 'inline-block',
                  width: '12px',
                  height: '12px',
                  background: 'lime',
                  borderRadius: '50%',
                  marginRight: '8px'
                }}></span>
                <span>Perfect - Capturing...</span>
              </div>
            </div>
          </div>
        </div>
      )}
      {mode === 'registration' && (
        <FaceCaptureComponent
          apiEndpoint={`${API_BASE_URL}/add-new-face`}
          goBack={handleBack}
          isTest={false}
          action="register"
        />
      )}

      {mode === 'punchin' && (
        <FaceCaptureComponent
          apiEndpoint={`${API_BASE_URL}/test-face`}
          goBack={handleBack}
          isTest={true}
          action="punch_in"
        />
      )}
      {mode === 'punchout' && (
        <FaceCaptureComponent
          apiEndpoint={`${API_BASE_URL}/test-face`}
          goBack={handleBack}
          isTest={true}
          action="punch_out"
        />
      )}
      {mode === 'breakin' && (
        <FaceCaptureComponent
          apiEndpoint={`${API_BASE_URL}/test-face`}
          goBack={handleBack}
          isTest={true}
          action="break_in"
        />
      )}
      {mode === 'breakout' && (
        <FaceCaptureComponent
          apiEndpoint={`${API_BASE_URL}/test-face`}
          goBack={handleBack}
          isTest={true}
          action="break_out"
        />
      )}

    </div>
  );
}

export default App;
